export const generateLocalTask = (item, fromDate, toDate) => {
  if (!item) {
    return null;
  }

  return {
    requestId: item.id,
    fromDate: fromDate.utc().format(),
    toDate: toDate.utc().format(),
    visible: true,
    worker: item.executer,
    fullAddress: item.fullAddress.trim(),
    withPopover: true,
    taskId: item.taskId,
  };
};
